module.exports = __webpack_public_path__ + "img/geofisica2_4-3_3072.7db0db2e.jpg";